import { render, staticRenderFns } from "./driverFeedback.vue?vue&type=template&id=2f260446&scoped=true"
import script from "./driverFeedback.vue?vue&type=script&lang=js"
export * from "./driverFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f260446",
  null
  
)

export default component.exports